// Styles
import "./Costs.scss";

// External Types
import { RecapPageComponentLine, RecapPageCostLine } from "@sky/quotations-typescript-angular-sdk";

//Types
export type OneShotOrRecurringOrFinancial = "one-shot" | "recurring" | "financial";
export type CostsProps = {
	costs: RecapPageComponentLine;
	type: OneShotOrRecurringOrFinancial;
};
export const showProductFinalPriceComponent = (
	type: string,
	costLine: RecapPageComponentLine
): string => {
	return showFinalPrice(
		type,
		"partialFinalPrice",
		"partialListPrice",
		"partialIsPrepaid",
		costLine,
		false
	);
};

export const showProductFinalPrice = (
	type: string,
	costLine: RecapPageComponentLine | RecapPageCostLine
): string => {
	return showFinalPrice(type, "finalPrice", "listPrice", "isPrepaid", costLine, true);
};

const showFinalPrice = (
	type: string,
	finalPrice: "finalPrice" | "partialFinalPrice",
	listPrice: "listPrice" | "partialListPrice",
	isPrepaid: "isPrepaid" | "partialIsPrepaid",
	costLine: RecapPageComponentLine | RecapPageCostLine,
	totalPartial: boolean
): string => {
	const isRecurring = type === "recurring";
	const currentFinalPrice = finalPrice as never;

	if (isRecurring && costLine[isPrepaid as never]) {
		return "PREPAGATO";
	}

	if (
		costLine?.[currentFinalPrice] !== undefined &&
		totalPartial &&
		costLine?.[currentFinalPrice] === 0 &&
		costLine?.[listPrice as never] === 0
	) {
		return "INCLUSO";
	}

	return `${(costLine?.[currentFinalPrice] as number)?.toFixed(2).replace(".", ",")}€`;
};

export const labelMapper: Record<string, string> = {
	"one-shot": "oneShot-title",
	financial: "financial-title"
};
export const priceLabelMapper: Record<string, string> = {
	"one-shot": "oneShot",
	financial: "financial"
};

// Element
export const Costs = (props: CostsProps): JSX.Element => {
	const { costs, type } = props;
	const titleClass = labelMapper[type] || "recurring-title";

	return (
		<>
			<div className="cost">
				<div className="cost__details title">
					<span className={`cost__label medium ${titleClass}`}>{costs?.title}</span>
				</div>
				<span className={`cost__price medium ${priceLabelMapper[type] || "recurring"}`}>
					{showProductFinalPriceComponent(type, costs)}{" "}
				</span>
			</div>
			{costs?.partialListPriceLabel || costs?.partialValidityLabel ? (
				<div className={`cost__recurring ${titleClass} partialListPriceLabel`}>
					{costs?.partialListPriceLabel && (
						<span className="medium bold">{costs.partialListPriceLabel}</span>
					)}
					{costs?.partialValidityLabel && (
						<span className="medium cost__validitylabel">
							{costs.partialValidityLabel}
						</span>
					)}
				</div>
			) : null}

			{costs?.costLines?.map((cost: RecapPageCostLine, idx: number) => (
				<div key={cost.productCode ?? `cost_${idx}`}>
					<div
						className={`cost ${cost?.productSubDescription ? "cost__skyInsider" : ""}`}
					>
						<div className="cost__details">
							<span className="cost__label">{cost?.productName}</span>
						</div>
						{cost?.alternativePriceLabel ? (
							<div className="cost__alternativePriceLabel medium">
								<span>{cost.alternativePriceLabel}</span>
							</div>
						) : null}
						{!cost?.alternativePriceLabel &&
							!!cost &&
							typeof cost.finalPrice === "number" && (
								<span className="cost__price medium">
									{showProductFinalPrice(type, cost)}
								</span>
							)}
					</div>
					{cost?.productSubDescription ? (
						<div className="cost__productSubDescription">
							<span>{cost.productSubDescription}</span>
						</div>
					) : null}
					{!cost?.alternativePriceLabel && cost?.discountLabel ? (
						<div className="cost__recurring">
							<span className="medium">{cost.discountLabel}</span>
						</div>
					) : null}
				</div>
			))}
		</>
	);
};

export default Costs;
